import image from '../../images/Stories (1).png';
import image2 from '../../images/Stories (2).png';
import image3 from '../../images/Stories (3).png';
import image4 from '../../images/Stories (4).png';
import image5 from '../../images/Stories (5).png';
const StoriesSection = () => {
  const stories = [
    {
      id: 1,
      type: 'large',
      badge: 'Climate Tech',
      title: 'Business Partnerships',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image2,
      readMoreText: 'Read Blog'
    },
    {
      id: 2,
      type: 'large',
      badge: 'Community Impact',
      title: 'Community Impact',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image3,
      readMoreText: 'Read Blog'
    },
    {
      id: 3,
      type: 'small',
      badge: 'Carbon Offset',
      title: 'Carbon Offset Projects',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image4,
      readMoreText: 'Read Blog'
    },
    {
      id: 4,
      type: 'small',
      badge: 'NGO Partnerships',
      title: 'NGO Collaborations',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image5,
      readMoreText: 'Read Blog'
    },
    {
      id: 5,
      type: 'small',
      badge: 'Social Impact',
      title: 'Bring Hope - Feed A Soul',
      description: 'Discuss the ways technology and innovation are helping to lower carbon emissions, from smart energy management to data analytics...',
      date: '02 November 2024',
      image: image,
      readMoreText: 'Read Blog'
    }
  ];

  const LargeCard = ({ data }) => (
    <div className="flex flex-col items-start pb-6 gap-6 w-[588px] h-[550px]">
      {/* Image Container */}
      <div className="relative w-full h-[361px] rounded-t-xl overflow-hidden">
        <img 
          src={data.image} 
          alt={data.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      
      {/* Content Container */}
      <div className="flex flex-col items-start gap-2 w-full">
        {/* Meta Row */}
        <div className="flex flex-row items-center gap-2 h-[25px]">
          <div className="bg-[#004617] rounded px-1.5 py-0.5 h-[25px] flex items-center">
            <span className="text-white font-medium text-[14px] leading-[21px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
              {data.badge}
            </span>
          </div>
          <div className="w-2.5 h-2.5 bg-[#D9D9D9] rounded-full"></div>
          <span className="text-[#898989] font-medium text-[14px] leading-[17px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.date}
          </span>
        </div>
        
        {/* Title & Description */}
        <div className="flex flex-col items-start gap-2 w-full mt-2">
          <h3 className="text-[#141414] font-bold text-[24px] leading-[29px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.title}
          </h3>
          <p className="text-[#3B3B3B] font-normal text-[16px] leading-[22px] w-full">
            {data.description}
          </p>
        </div>
        
        {/* Read More Link */}
        <div className="flex flex-row items-center gap-1 mt-3 cursor-pointer group transition-all duration-150 hover:opacity-80">
          <span className="text-[#0D924F] font-medium text-[16px] leading-[19px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.readMoreText}
          </span>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6H15M15 6L10 1M15 6L10 11" stroke="#0D924F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  );

  const SmallCard = ({ data }) => (
    <div className="flex flex-col items-start gap-6 w-[384px] h-[489px]">
      {/* Image Container */}
      <div className="relative w-full h-[302px] rounded-t-xl overflow-hidden">
        <img 
          src={data.image} 
          alt={data.title}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      
      {/* Content Container */}
      <div className="flex flex-col items-start gap-2 w-full">
        {/* Meta Row */}
        <div className="flex flex-row items-center gap-2 h-[25px]">
          <div className="bg-[#004617] rounded px-1.5 py-0.5 h-[25px] flex items-center">
            <span className="text-white font-medium text-[14px] leading-[21px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
              {data.badge}
            </span>
          </div>
          <div className="w-2.5 h-2.5 bg-[#D9D9D9] rounded-full"></div>
          <span className="text-[#898989] font-medium text-[14px] leading-[17px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.date}
          </span>
        </div>
        
        {/* Title & Description */}
        <div className="flex flex-col items-start gap-2 w-full mt-2">
            <h3 className="text-[#141414] font-bold text-[24px] leading-[29px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.title}
          </h3>
          <p className="text-[#3B3B3B] font-normal text-[16px] leading-[22px] w-full line-clamp-3">
            {data.description}
          </p>
        </div>
        
        {/* Read More Link */}
        <div className="flex flex-row items-center gap-1 mt-3 cursor-pointer group transition-all duration-150 hover:opacity-80">
          <span className="text-[#0D924F] font-medium text-[16px] leading-[19px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
            {data.readMoreText}
          </span>
          <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 6H15M15 6L10 1M15 6L10 11" stroke="#0D924F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-start gap-4 w-full mb-20 max-w-[1200px] h-auto ml-60 mt-20">
      {/* Section Title */}
      <h2 className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[117px] h-[43px]" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
        Stories
      </h2>
      
      {/* Responsive Grid Container */}
      <div className="flex flex-row flex-wrap items-start gap-6 w-full min-h-[1063px]">
        {/* First Large Card */}
        <LargeCard data={stories[0]} />
        
        {/* Second Large Card */}
        <LargeCard data={stories[1]} />
        
        {/* Three Small Cards */}
        <SmallCard data={stories[2]} />
        <SmallCard data={stories[3]} />
        <SmallCard data={stories[4]} />
      </div>
    </div>
  );
};

export default StoriesSection;